<template>
  <div :class="{ container: !isfirst, firstContainer: isfirst }">
    <h2
      :class="{
        requiredhighlight: showrequired && selected === -1,
        qtitle: deselectable,
        requiredqtitle: !deselectable,
        dotransition: true,
      }"
    >
      {{ text }}
    </h2>
    <h6
      :class="{
        requiredtext: true,
        requiredtexthighlight: showrequired && selected === -1,
        dotransition: true,
      }"
      v-if="!deselectable"
    >
      Required
    </h6>
    <div class="surveycontainer">
      <div class="optionContainer">
        <div
          :class="{
            selected: this.selected === index,
            deselected: this.selected !== index,
            option: true,
          }"
          v-for="(option, index) in options"
          :key="index"
          @click="select(index)"
        >
          <h2>{{ option.label }}</h2>
        </div>
      </div>
      <div class="labelContainer">
        <h4 class="llabel">{{ ltext }}</h4>
        <h4 class="clabel">{{ ctext }}</h4>
        <h4 class="rlabel">{{ rtext }}</h4>
      </div>
      <div
        class="labelpadding"
        v-if="ltext !== '' || ctext !== '' || rtext !== ''"
      ></div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import pointsStore from "../pointsStore.js";

export default defineComponent({
  methods: {
    select(id) {
      if (this.selected !== id) {
        this.selected = id;
        pointsStore.setResponse(
          this.$props.id,
          this.$props.options[id].points,
          this.$props.category
        );
        return;
      }
      if (this.selected === id && this.deselectable) {
        this.selected = -1;
        pointsStore.delResponse(this.$props.id);
      }
    },
  },
  data() {
    return {
      selected: -1,
    };
  },
  name: "Question",
  props: {
    isfirst: Boolean,
    id: Number,
    text: String,
    options: Object,
    showrequired: { type: Boolean, default: false },
    ltext: { type: String, default: "" },
    ctext: { type: String, default: "" },
    rtext: { type: String, default: "" },
    deselectable: { type: Boolean, default: false },
    category: String,
  },
});
</script>

<style scoped>
.container {
  display: flex;
  align-items: flex-start;
  padding-left: 2rem;
  padding-right: 2rem;
  flex-direction: column;
  margin-top: 2rem;
  margin-bottom: 3rem;
}

.firstContainer {
  display: flex;
  align-items: flex-start;
  padding-left: 2rem;
  padding-right: 2rem;
  flex-direction: column;
  margin-top: 0;
  margin-bottom: 2rem;
}

.surveycontainer {
  width: 100%;
}

.optionContainer {
  display: flex;
  width: 100%;
}

.option {
  flex-basis: 100%;
  display: flex;
  flex-direction: column;
  margin: 0.2rem;
  padding: 0.1rem 0.2rem 0.1rem 0.2rem;
  border-radius: 1rem;
  transition: 0.25s;
  cursor: pointer;
}

.selected {
  background-color: #007bff;
  color: #ffff;
}

.deselected {
  background-color: #dddddd;
  color: #000010;
}

.option > h2 {
  margin: 1rem;
}

.labelContainer {
  position: relative;
  width: 100%;
}

.llabel,
.clabel,
.rlabel {
  position: absolute;
  margin-top: 0.4rem;
}

.llabel {
  left: 0.5rem;
}

.clabel {
  left: 50%;
  transform: translate(-50%, 0);
}

.rlabel {
  right: 0.5rem;
}

.labelpadding {
  height: 1rem;
}

.dotransition {
  transition: 300ms;
}

.requiredhighlight {
  color: rgb(216, 18, 18);
}

.requiredtexthighlight {
  color: rgb(247, 75, 75);
}

.qtitle {
  margin-bottom: 0.7rem;
  text-align: left;
}

.requiredqtitle {
  margin-bottom: 0.3rem;
  text-align: left;
}

.requiredtext {
  margin: 0 0 0.3rem 0.2rem;
}
</style>